import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles(({ spacing, palette, typography, radius }) => ({
  paper: {
    borderTopLeftRadius: spacing(2),
    borderTopRightRadius: spacing(2),
    // Leave the top of the page showing so the sheet still reads as a layer.
    maxHeight: '85vh',
    // Clear the home indicator on phones that have one.
    paddingBottom: `calc(${spacing(1)} + env(safe-area-inset-bottom))`
  },
  handle: {
    flexShrink: 0,
    width: spacing(4),
    height: spacing(0.5),
    borderRadius: radius.xs,
    backgroundColor: palette.grey.shade[20],
    margin: `${spacing(1)} auto ${spacing(0.5)}`
  },
  title: {
    padding: `${spacing(1)} ${spacing(3)} ${spacing(0.5)}`,
    margin: 0,
    color: palette.text.secondary,
    fontWeight: typography.fontWeightMedium,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}))
